// src/pages/PostDetailPage.js
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../utils/api';
import PostCard from '../components/posts/PostCard';
import CommentList from '../components/comments/CommentList';
import CommentForm from '../components/comments/CommentForm';
import '../styles/post-detail-page.css';

const PostDetailPage = () => {
  const { postId } = useParams();
  const navigate = useNavigate();
  
  const [post, setPost] = useState(null);
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  
  useEffect(() => {
    fetchPostDetails();
  }, [postId]);
  
  const fetchPostDetails = async () => {
    try {
      setLoading(true);
      
      // Fetch post
      const postResponse = await api.get(`/api/posts/${postId}`);
      setPost(postResponse.data);
      
      // Fetch comments
      const commentsResponse = await api.get(`/api/comments/post/${postId}`);
      setComments(commentsResponse.data.comments);
      
    } catch (err) {
      console.error('Error fetching post details:', err);
      setError('Failed to load post');
    } finally {
      setLoading(false);
    }
  };

  const handleNewComment = (newComment) => {
    setComments([newComment, ...comments]);
    
    // Update post comment count
    setPost(prevPost => ({
      ...prevPost,
      commentCount: (prevPost.commentCount || 0) + 1
    }));
  };

  const handlePostUpdate = async (reactionType = 'like') => {
    try {
      const token = localStorage.getItem('token');

      const res = await api.post(`/api/posts/${postId}/react`, 
        { reactionType }, 
        {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
      );

      if (res.status === 200) {
        const updatedPost = res.data.post;
        
        // 🧠 Update post state directly without full fetch
        setPost(prevPost => ({
          ...prevPost,
          reactions: updatedPost.reactions,
          userReaction: updatedPost.userReaction
        }));

      } else {
        console.error('❌ Failed to react to post');
      }
    } catch (error) {
      console.error('Error reacting to post:', error);
    }
  };
  
  if (loading) {
    return <div className="loading">Loading post...</div>;
  }
  
  if (error) {
    return <div className="error-message">{error}</div>;
  }
  
  if (!post) {
    return <div className="error-message">Post not found</div>;
  }
  
  return (
    <div className="post-detail-page">
      <div className="post-detail-header">
        <button className="back-button" onClick={() => navigate(-1)}>
          ← Back
        </button>
        <h1>Post</h1>
      </div>
      
      <PostCard 
        post={post} 
        showComments={false} 
        onReact={handlePostUpdate}
      />
      
      <div className="comments-container">
        <h2 className="comments-heading">Comments</h2>
        
        <CommentForm 
          postId={post.id} 
          onCommentAdded={handleNewComment} 
        />
        
        <CommentList comments={comments} loading={false} />
      </div>
    </div>
  );
};

export default PostDetailPage;
